module.exports = __webpack_public_path__ + "img/9788955138177.5cbe743d.jpg";